/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListDetailedResponse {
    getFixupPrototypeFunction() { return ListDetailedResponse.fixupPrototype; }

    static newInstance(model: Partial<ListDetailedResponse>): ListDetailedResponse {
        let obj = Object.assign(new ListDetailedResponse(), model);
        ListDetailedResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListDetailedResponse>): ListDetailedResponse {
        if (!model) return null;
        return ListDetailedResponse.newInstance(<ListDetailedResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListDetailedResponse) {
        if (!obj) return;

        models.ListDetailedResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListDetailedResponse): boolean {
        Object.setPrototypeOf(obj, ListDetailedResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.RecordIdentity>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
